import { memo, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useGetChildInformedConsentQuery } from '@/services/child-api';
import { ThumbsDownSvg, ThumbsUpSvg } from '@/assets/icons';
import Table from '@/components/table';
import Button from '@/components/button';
import EditModal from './edit-modal';

const icons = {
  no: <ThumbsDownSvg />,
  yes: <ThumbsUpSvg />,
};

const RecruitmentRequests = ({ childId, permissions }) => {
  const { search } = useLocation();
  const queryParams = new URLSearchParams(search);
  const pageNumber = queryParams.get('page') || 1;
  const { data, isFetching, refetch } = useGetChildInformedConsentQuery({ childId, pageNumber });

  const [selectedItem, setSelectedItem] = useState();

  const columns = [
    {
      title: 'Task',
      dataIndex: 'type',
      render: (value) => value.name,
    },
    {
      title: 'Status',
      dataIndex: 'status',
      render: (value) => (
        <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
          {icons[value.code]}
          {value.name}
        </div>
      ),
    },
    {
      title: 'Note',
      dataIndex: 'notes',
      ellipsis: true,
    },
    permissions.writeChild && {
      title: 'Action',
      key: 'action',
      align: 'right',
      width: 80,
      render: (_, record) => (
        <Button type="link" onClick={() => setSelectedItem(record)}>
          Edit
        </Button>
      ),
    },
  ].filter((item) => item);

  return (
    <>
      <Table
        columns={columns}
        dataSource={data?.data}
        rowKey="childInformedConsentId"
        loading={isFetching}
        pageInfo={data}
        size="small"
      />
      <EditModal childId={childId} item={selectedItem} refetch={refetch} onClose={() => setSelectedItem()} />
    </>
  );
};

export default memo(RecruitmentRequests);
